import { NgModule } from "@angular/core";
import { LoggedInGuard } from 'src/app/guards/logged-in.guard';
import { PagesComponent } from '../pages.component';
import { RouterModule, Routes } from '@angular/router';
import { DocsByUserComponent } from './docsbyuser/docs-by-user.component';
import { DocsPendingComponent } from './docspending/docs-pending.component';
import { DocsByDayComponent } from './docsbyday/docs-by-day.component';
import { DocsGlobalComponent } from './docsglobal/docs-global.component';
import { DocsPendingByUserComponent } from './docspendingbyuser/docs-pending-by-user.component';
import { DocsByNifComponent } from './docsbynif/docs-by-nif.component';
import { NifBySecundaryComponent } from './nifbysecundary/nif-by-secundary.component';
import { DocsUpdatedByDayComponent } from './docsupdatedbyday/docs-updated-by-day.component';
import { TrazadoEstadoDocsComponent } from './trazadoEstadoDocumentos/trazadoEstadoDocs.component';
import { ProcesadasRobotComponent } from './procesadasRobot/procesadasRobot.component';
import { ListadoPendientesPlantillasComponent } from './listado-pendientes-plantillas/listado-pendientes-plantillas.component';
import { FalloProcAutoComponent } from './fallo-proc-auto/fallo-proc-auto.component';
import { ListadoDatosDocsSubidosPrincComponent } from './listado-datos-docs-subidos-princ/listado-datos-docs-subidos-princ.component';
import { DocsSecunTerceroComponent } from './docsSecunTerceros/docs-secun-tercero.component';
import { DocsByUserSUPComponent } from "./docsbyuserSUP/docs-by-userSUP.component";
import { DocsMultifacturaComponent } from "./docsMultifactura/docs-multifactura.component";

const routes: Routes = [
  {
    path: 'Stats', component: PagesComponent, canActivate: [LoggedInGuard], children: [
      { path: 'DocsByUser', component: DocsByUserComponent, canActivate: [LoggedInGuard] },
      { path: 'DocsMultifactura', component: DocsMultifacturaComponent, canActivate: [LoggedInGuard] },
      { path: 'DocsByUserSUP', component: DocsByUserSUPComponent, canActivate: [LoggedInGuard] },
      { path: 'DocsPending', component: DocsPendingComponent, canActivate: [LoggedInGuard] },
      { path: 'DocsByDay', component: DocsByDayComponent, canActivate: [LoggedInGuard] },
      { path: 'DocsGlobal', component: DocsGlobalComponent, canActivate: [LoggedInGuard] },
      { path: 'DocsPendingByUser', component: DocsPendingByUserComponent, canActivate: [LoggedInGuard] },
      { path: 'DocsByNif', component: DocsByNifComponent, canActivate: [LoggedInGuard] },
      { path: 'DocsByNifAndSecundary', component: NifBySecundaryComponent, canActivate: [LoggedInGuard] },
      { path: 'DocsUpdatedByDay', component: DocsUpdatedByDayComponent, canActivate: [LoggedInGuard] },
      { path: 'DocsState', component: TrazadoEstadoDocsComponent, canActivate: [LoggedInGuard] },
      { path: 'ProcesadasRobot', component: ProcesadasRobotComponent, canActivate: [LoggedInGuard] },
      { path: 'PendientesPlantillas', component: ListadoPendientesPlantillasComponent, canActivate: [LoggedInGuard] },
      { path: 'FalloProcAuto', component: FalloProcAutoComponent, canActivate: [LoggedInGuard] },
      { path: 'ListadoDatosDocsSubidosPrinc', component: ListadoDatosDocsSubidosPrincComponent, canActivate: [LoggedInGuard] },
      { path: 'ListadoDocsSecunTerceros', component: DocsSecunTerceroComponent, canActivate: [LoggedInGuard] },
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ],
  declarations: []
})
export class StatsRoutingModule { }

